export default "__VITE_ASSET__DodeskKj__"